module.exports = __webpack_public_path__ + "img/superhero.85fb22b2.jpg";